<script lang="ts" setup>
import { NetworkErrorType } from '@/types/enum'

const appStore = useAppStore()

withDefaults(
  defineProps<{
    isSm?: boolean
    search?: string
    isEmpty?: boolean
    networkErrorType: NetworkErrorType
  }>(),
  {
    search: ''
  }
)
</script>

<template>
  <div>
    <slot name="header" />
    <div
      v-if="isEmpty || appStore.networkErrorTypes.includes(networkErrorType)"
      class="flex flex-col items-center justify-center mt-4"
      :class="{ 'h-32': isSm, 'min-h-xs pb-14': !isSm }"
    >
      <SharedIcon name="not-found" class="min-w-6 mb-2 h-10 w-10 text-white" />
      <div class="text-sm text-uiGray-600">
        <span v-if="appStore.networkErrorTypes.includes(networkErrorType)">
          {{ $t(`networkError.${networkErrorType}`) }}
        </span>
        <span v-else-if="search.trim()">{{
          $t('noRecord.noResultsFound', { search })
        }}</span>
        <span v-else>{{ $t(`noRecord.${networkErrorType}`) }}</span>
      </div>
    </div>
    <slot v-else />
  </div>
</template>
